import PropTypes from 'prop-types';
import React, { memo } from 'react';

import LoadAnimation from '../decorators/LoadAnimation';
import Popup from '../helpers/Popup';
import FormGroup from '../helpers/FormGroup';
import BaseSelect from '../helpers/Select';
import Button from '../helpers/Button';
import PrettyError from '../decorators/PrettyError';
import DisplayError from '../decorators/DisplayError';
import BaseBoard from './BIC';
import { createIndustryErrorMessage } from '../../utils/industryTagsHelper';
import useRequiredFieldErrors from '../../hooks/useRequiredFieldErrors';

const Select = PrettyError(DisplayError(BaseSelect));
const Board = PrettyError(DisplayError(BaseBoard));

const BuyerRolePopup = props => {
  const { info, onClose } = props;
  const header = 'Activate Buyer role for this company';

  const footer = (
    <>
      <Button
        key="save"
        className="btn-primary"
        disabled={!info.get('isValid')}
        form="popup-add-buyer-role-form"
        type="submit"
      >
        Save
      </Button>
      <Button key="close" onClick={onClose}>
        Close
      </Button>
    </>
  );

  return (
    <Popup footer={footer} header={header} id="newPastMain">
      <LoadableForm {...props} />
    </Popup>
  );
};

BuyerRolePopup.propTypes = {
  onChange: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
};

const Form = props => {
  const { info, onChange, onSave, suggestHarvco, error, businessModels, onClick, tags, onErrorClose } = props;

  const { errors: requiredErrors, formProps } = useRequiredFieldErrors();

  const errorMessage = createIndustryErrorMessage(error);

  return (
    <form id="popup-add-buyer-role-form" onChange={onChange} onSubmit={onSave} {...formProps}>
      <div className="row">
        <FormGroup className="col-sm-6">
          <Select
            canDisplayError={Boolean(requiredErrors.buyerType)}
            className="input-sm"
            disabled={info.get('disabledType')}
            error={requiredErrors.buyerType}
            label="Buyer Type"
            name="buyerType"
            onChange={onChange}
            options={info.get('buyerTypes')}
            root={info}
            autoFocus
            deep
            required
            showLabel
          />
        </FormGroup>
        <div className="col-sm-6">{suggestHarvco}</div>
      </div>
      <div className="row">
        <div className="col-xs-12">
          <Board
            error={errorMessage}
            models={businessModels}
            name="industryCategoryIds"
            onClick={onClick}
            onErrorClose={onErrorClose}
            tags={tags}
            canDisplayError
          />
        </div>
      </div>
    </form>
  );
};

const LoadableForm = LoadAnimation(Form);

export default memo(BuyerRolePopup);
